export enum ExaminationGrade {
    Pass = 1,
    Fail = 2,
    NoGrade = 3
}